import styled from 'styled-components';

const UI_Item = styled.div`
  border-radius: 4px;

  @media (max-width: 768px) {
    margin: 0 2px;

    button, div {
      padding: 8px 10px !important;
      font-size: 14px !important;
      min-width: 44px;
      min-height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  @media (max-width: 480px) {
    margin: 0 1px;

    button, div {
      padding: 10px 12px !important;
      font-size: 16px !important;
      min-width: 48px;
      min-height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
`;
export const UI_HeaderStyles = {
  UI_Item,
};
